export enum Scenes {
  MAIN_MENU_SCENE = 'mainMenu',
  BOARD_SCENE = 'board',
  MUSIC_SCENE = 'music',
}
